import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom'; 
import { storage, db } from '../lib/firebase';
import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from 'firebase/storage';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import './Kyc.css'; 
import { dummy } from '../assets';
import CryptoMarquee from '../Chart/CryptoMarquee';
import { FaArrowLeft } from 'react-icons/fa'; 

const Kyc = () => {
  const { userId } = useParams(); // Get userId from the URL
  const [tierOne, setTierOne] = useState('');
  const [tierTwo, setTierTwo] = useState('');
  const [tierOneImageUrl, setTierOneImageUrl] = useState('');
  const [tierTwoImageUrl, setTierTwoImageUrl] = useState('');
  const [loading, setLoading] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [successMessage, setSuccessMessage] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [profilePictureUrl, setProfilePictureUrl] = useState(''); // State to hold profile picture URL
  const [username, setUsername] = useState(''); // State to hold the username


  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserKYC = async () => {
      const userDocRef = doc(db, 'users', userId);
      const userDoc = await getDoc(userDocRef);
      if (userDoc.exists()) {
        const data = userDoc.data();
        setTierOne(data.tierOne || '');
        setTierTwo(data.tierTwo || '');
        setTierOneImageUrl(data.tierOneImageUrl || '');
        setTierTwoImageUrl(data.tierTwoImageUrl || '');
        setProfilePictureUrl(data.profilePictureUrl || ''); // Fetch the profile picture
        setUsername(data.username || ''); // Fetch and set the username

      }
    };

    fetchUserKYC();
  }, [userId]);

  const handleImageUpload = (e, tier) => {
    setLoading(true);
    const file = e.target.files[0];
    if (!file) return;

    const storageRef = ref(storage, `escrow_images/${tier}/${userId}/${file.name}`);
    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      'state_changed',
      (snapshot) => {
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        console.log(`Upload is ${progress}% done`);
      },
      (error) => {
        console.error('Error uploading image:', error);
        setLoading(false);
        setErrorMessage('Error uploading image.');
        setTimeout(() => setErrorMessage(''), 6000); 
      },
      async () => {
        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
        if (tier === 'tier1') {
          setTierOneImageUrl(downloadURL);
        } else if (tier === 'tier2') {
          setTierTwoImageUrl(downloadURL);
        }
        setLoading(false);
      }
    );
  };

  const handleDeleteImage = async (tier) => {
    setLoading(true);
    try {
      const imageUrl = tier === 'tier1' ? tierOneImageUrl : tierTwoImageUrl;
      if (imageUrl) {
        const imageRef = ref(storage, imageUrl);
        await deleteObject(imageRef);

        if (tier === 'tier1') {
          setTierOneImageUrl('');
        } else if (tier === 'tier2') {
          setTierTwoImageUrl('');
        }

        const userDocRef = doc(db, 'users', userId);
        await setDoc(
          userDocRef,
          {
            [`${tier}ImageUrl`]: '',
          },
          { merge: true }
        );

        setSuccessMessage(`Image deleted successfully for ${tier.toUpperCase()}.`);
        setTimeout(() => setSuccessMessage(''), 6000); 
      }
    } catch (error) {
      console.error('Error deleting image:', error);
      setErrorMessage('Failed to delete image. Please try again.');
      setTimeout(() => setErrorMessage(''), 6000); 
    }
    setLoading(false);
  };

  const handleTierChange = (e, tier) => {
    const value = e.target.value;
    if (tier === 'tier1') {
      setTierOne(value);
    } else if (tier === 'tier2') {
      setTierTwo(value);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault(); 

    setLoading(true);
    setSuccessMessage('');
    setErrorMessage('');

    try {
      const userDocRef = doc(db, 'users', userId);
      await setDoc(
        userDocRef,
        {
          tierOne,
          tierOneImageUrl,
          tierTwo,
          tierTwoImageUrl,
        },
        { merge: true }
      );
      setSuccessMessage('KYC data submitted successfully.');
      setTimeout(() => setSuccessMessage(''), 6000); 
      setIsEditMode(false);
    } catch (error) {
      console.error('Error submitting KYC data:', error);
      setErrorMessage('Failed to submit KYC. Please try again.');
      setTimeout(() => setErrorMessage(''), 6000); 
    }
    setLoading(false);
  };

  const toggleEditMode = () => {
    setIsEditMode(!isEditMode);
    setSuccessMessage('');
    setErrorMessage('');
  };

  const handleGoBack = () => {
    navigate(-1); 
  };

  return (
    <div className='pageCover'>
      <div>
        <FaArrowLeft onClick={handleGoBack} className="reset" />
      </div>
      <CryptoMarquee />

      <div className="kyc-container">
        <img
          src={profilePictureUrl || dummy}
          alt="Profile"
          className="profile-img"
        />
          <h1 className='center'> <div className=""></div>{username || userId}</h1> 

        {successMessage && <div className="success-message">{successMessage}</div>}
        {errorMessage && <div className="error-message">{errorMessage}</div>}

        <p className="center edit-btn" onClick={toggleEditMode}>
          {isEditMode ? 'Cancel' : 'Update KYC'}
        </p>

        {isEditMode ? (
          <form onSubmit={handleSubmit} className="kyc-form">
            <div className="kyc-fields">
              <div className="kyc-field">
                <label>Tier 1:</label>
                <select value={tierOne} onChange={(e) => handleTierChange(e, 'tier1')} className="kyc-select">
                  <option value="">Select an option</option>
                  <option value="NIN">National Identification Number</option>
                  <option value="driversLicense">Driver's License</option>
                  <option value="passport">Passport</option>
                </select>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleImageUpload(e, 'tier1')}
                  className="kyc-file-input"
                />
                {tierOneImageUrl && (
                  <>
                    <a className='success-message' href={tierOneImageUrl} target="_blank" rel="noopener noreferrer">View Image</a>
                    <button
                      type="button"
                      className="error-message"
                      onClick={() => handleDeleteImage('tier1')}
                    >
                      Delete Image
                    </button>
                  </>
                )}
              </div>

              <div className="kyc-field">
                <label>Tier 2:</label>
                <select value={tierTwo} onChange={(e) => handleTierChange(e, 'tier2')} className="kyc-select">
                  <option value="">Select an option</option>
                  <option value="bankStatement">Upload Bank Statement</option>
                  <option value="utilityBill">Utility Bill</option>
                  <option value="residencyCertificate">Certificate of Residency</option>
                </select>
                <input
                  type="file"
                  accept="image/*"
                  onChange={(e) => handleImageUpload(e, 'tier2')}
                  className="kyc-file-input"
                />
                {tierTwoImageUrl && (
                  <>
                    <a className='success-message' href={tierTwoImageUrl} target="_blank" rel="noopener noreferrer">View Image</a>
                    <button
                      type="button"
                      className="error-message"
                      onClick={() => handleDeleteImage('tier2')}
                    >
                      Delete Image
                    </button>
                  </>
                )}
              </div>
            </div>

            <button type="submit" className="submit-btn" disabled={loading}>
              {loading ? 'loading ...' : 'Submit'}
            </button>
          </form>
        ) : (
          <div className="kyc-fields">
            <div className='kyc-field'>
              <h3>Tier 1: {tierOne || 'Not Verified!'}</h3>
              {tierOneImageUrl && <div className='success-message'><a className='success-message' href={tierOneImageUrl} target="_blank" rel="noopener noreferrer">View KYC Document</a></div>}
            </div>
            <div className='kyc-field'>
              <h3>Tier 2: {tierTwo || 'Not Verified!'}</h3>
              {tierTwoImageUrl && <div className='success-message'><a className='success-message' href={tierTwoImageUrl} target="_blank" rel="noopener noreferrer">View KYC Document</a></div>}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Kyc;
